import React, { Component } from "react";

import { Button } from 'antd';
import { Toast } from 'antd-mobile'
import WidgetRadio from "./../../widget/WidgetRadio";
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import WidgetModal from "./../../widget/WidgetModal";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
            pageType: 1,
            optionsData: [],
            groupData: [
                {
                    value: 'true',
                    title: '是'
                },{
                    value: 'false',
                    title: '否'
                }
            ],
            isGiveService: 'true',
            settingInfo: {},
            modelOptions: {
                type: 'message',
                title: ' ',
                index: 0,
                message: null,
                isNext: false,
                isOk: true,
                wrapClassName: 'sg-index-model',
                bodyStyle: { padding: 0 },
            },
            modal: null,
            isHide: true,
            codeNum: 5
        }
        this.onOk = this.onOk.bind(this);
    }
    componentDidMount(){
        this.setState({
            pageType: 1
        })
        this.getDefaultValue()
        this.tipsUser()
    }
    tipsUser(){
        let {modelOptions} = this.state
        if(!localStorage.getItem("_template_info_")){
            modelOptions.message = <div className="sg-index-body sd-columnCenter" style={{padding:'0 0.1041rem '}}>
                <img src={require('../../img/business/complete.png')} className="sg-layer-icon" alt="#" style={{margin: '9px 0 15px'}} />
                <div>未获取到您的区县</div>
                <div style={{marginBottom:'28px'}}>请前往申报综述，请选择您所在的省市区县！</div>
            </div>
            this.modal.open();
        }
    }
    getDefaultValue(){
        let str =localStorage.getItem("defaultValue")
        let arr = []
        if(str){
            arr = str.split(',') 
            this.beforehandBtn(arr[arr.length-1])
        }
        
    }
    beforehandBtn(SSQXID){
        WidgetAjax.ajax({
            url : Config.getBasePath()+'/businessSystem/setting', 
            params : {
                SSQXID
            }, 
            callback : (data)=>{
                if(data&&data.status === 0){
                    this.setState({
                        settingInfo: data.result
                    })
                }
            }
        },this);
    };
    onChange(value) {
        console.log(value);
    };
    onRadioChange(val){
        this.setState({
            isGiveService: val,
        })
    };
    backBtn(){
        let pageType =  this.state.pageType
        this.setState({
            pageType: pageType-1
        })
    }
    nextBtn(){
        let pageType =  this.state.pageType
        if(pageType === 1){
            this.getPhoneCode()
        }
        if(pageType === 2){
            this.submitBtn()
            return
        }
        this.setState({
            pageType: pageType+1
        })
    }
    submitBtn(){
        const {settingInfo} = this.state
        if(settingInfo.STATE==='0'){
            Toast.show({
                content: '您好，当前不在申报期，无申报任务，请在申报期内申报！',
                maskClickable: false,
            })
            return
        }
        if(settingInfo.SFSB==='1'){
            Toast.show({
                content: '您好，您已进行过申报，请耐心等待系统审核！',
                maskClickable: false,
            })
            return
        }
        if(!localStorage.getItem("_template_info_")){
            Toast.show({
                content: '请前往申报综述，请选择您所在的省市区县！',
                maskClickable: false,
            })
            return
        }
        if(!localStorage.getItem("ProvincialUrbanAreas")){
            Toast.show({
                content: '请前往申报综述，请选择您所在的省市区县！',
                maskClickable: false,
            })
            return
        }
        if(settingInfo.STATE==='1'&&settingInfo.SFSB==='0'){
            this.props.history.push({ pathname: "/home/judge", state: { isGiveService: this.state.isGiveService } });
        }else{

        }
    }
    onRef = (ref) => {
        this.modal =  ref;
    };
    onOk(type){
        this.props.history.push({ pathname: "/home/history", state: { showLabel: true } });
        this.modal.onClose();
    }
    renewCode(codeNum){
        this.setState({
          codeNum: codeNum
        })
    }
    getPhoneCode(){
        let codeNum = 5
        let timer = setInterval(()=>{
          codeNum = this.state.codeNum || codeNum
          if(codeNum > 0 && codeNum <= 5){
            codeNum--
            this.renewCode(codeNum)
          }else {
            clearInterval(timer);
          }
        },1000);
    }
    render()
    {
        const {pageType,modelOptions,isHide,settingInfo,codeNum} = this.state
        let year =settingInfo?.ND
        // eslint-disable-next-line
        let reg = /(\d{4})\-(\d{2})\-(\d{2})/
        return (
            <div data-component="filling">
                <div className="sg-filling">
                    <div className="sg-filling-title sd-middle">
                        <div className="sg-title-li sd-columnCenter">
                            <div className="sg-li-top sd-middle sg-change-li">1</div>
                            <div className="sg-li-font sg-color1">填报须知</div>
                        </div>
                        <div className="sg-title-line"></div>
                        <div className="sg-title-li sd-columnCenter">
                            <div className={`sg-li-top sd-middle ${pageType>1?'sg-change-li':''}`}>2</div>
                            <div className={`sg-li-font ${pageType>1?'sg-color1':''}`}>承诺声明</div>
                        </div>
                        {/* <div className="sg-title-line"></div>
                        <div className="sg-title-li sd-columnCenter">
                            <div className={`sg-li-top sd-middle ${pageType>2?'sg-change-li':''}`}>3</div>
                            <div className={`sg-li-font ${pageType>1?'sg-color1':''}`}>帮扶需求</div>
                        </div> */}
                    </div>
                    <div className="sg-filling-center">
                        <div style={{display: pageType === 1 ? "block" : "none"}}>
                            <div className="sg-center-font" style={{display:year?'block':'none'}} key={year}>1.您当前进入的申报是<span style={{color:'#1492FF'}}>{year}</span>年第一批次的全国“名特优新”个体工商户申报服务，申报期为<span style={{color:'#1492FF'}}>{settingInfo.STARTTIME?settingInfo.STARTTIME.replace(reg,"$1年$2月$3日"):''}</span>至<span style={{color:'#1492FF'}}>{settingInfo.ENDTIME?settingInfo.ENDTIME.replace(reg,"$1年$2月$3日"):''}</span>止，依据本省的申报要求不定期开启申报，请您关注相关日程安排，同时申报结果将在评定入库后向社会公示。</div>
                            <div className="sg-center-font">2.申报材料应真实反映个体工商户的实际情况，个体工商户对其公示信息的真实性、及时性负责。</div>
                            <div className="sg-center-font">3.本填报内容分为基本信息、分类标准、每项信息均需要进行填报；</div>
                            <div className="sg-center-font">4.个体工商户在申报期截止日前均可发起资料修改，系统在申报期截止后以最后一次提交材料为依据，未查询到提交记录，则认为未申报。</div>
                            <div className="sg-center-font">5.同一自然人在同一县级行政区域内设立多个个体工商户的，最多只能有一个个体工商户入库。</div>
                        </div>
                        
                        <div style={{display: pageType === 2 ? "block" : "none"}}>
                            <div className="sg-center-font">1.我承诺填报的信息均为实际情况，保证信息的真实性、及时性、准确性等。</div>
                            <div className="sg-center-font">2.我承诺申报的个体工商户无行政处罚、无被列为失信人、无经营异常等情况。</div>
                            <div className="sg-center-font">3.我承诺填写的信息及材料证明文件真实有效，一旦发现申报虚假材料所造成的后果自行承担。</div>
                            <div className="sg-center-font">4.我同意将我申报的材料，认定成功后向社会公示使用。</div>
                        </div>
                        

                        <div className="sg-center-list" style={{display: pageType === 3 ? "block" : "none"}}>
                            <div className="sg-center-font">评定成功后，是否需要政府提供相关的帮扶服务</div>
                            <div className="sg-center-option sd-start">
                                <WidgetRadio data={this.state.groupData} defaultValue={this.state.isGiveService} options={{isTitle:false}} onChange={(e)=>{this.onRadioChange(e)}}></WidgetRadio>
                            </div>
                        </div>
                    </div>
                    <div className="sg-filling-bottom sd-end">
                        <div className="sg-bottom-btn sd-middle sg-defined-btn" onClick={()=>{this.backBtn()}} style={{display: pageType > 1 ? "flex" : "none"}}>上一步</div>
                        <div className="sg-bottom-btn sd-middle" onClick={()=>{this.nextBtn()}} style={{display: pageType === 1 ? "flex" : "none"}}>下一步</div>
                        <Button className="sg-bottom-btn sd-middle" onClick={()=>{this.nextBtn()}} disabled={codeNum>0} style={{display: pageType === 2 ? "flex" : "none",background:codeNum>0?'#999':'#1492FF',border:'none',color:'#fff'}}>同意 <span style={{display:codeNum>0?'inline-block':'none',color:'#fff'}}>({codeNum}S)</span></Button>
                        <div className="sg-bottom-btn sd-middle" onClick={()=>{this.submitBtn()}} style={{display: pageType === 3 ? "flex" : "none"}}>确定</div>
                    </div>
                </div>
                <WidgetModal options={modelOptions} onRef={this.onRef} isHide={isHide} onOk={this.onOk}></WidgetModal>
            </div>
        )
    }
}

export default Index
